import React, { useState } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { Header, Button, Input } from "semantic-ui-react";
import { recordingBulkUpdate } from "../../actions/recordingActions";

const RecordingBulkUpdateForm = ({ projectId, closeModal }) => {
  const dispatch = useDispatch();
  const [error, setError] = useState();
  const [file, setFile] = useState();

  const validateFile = (f) => {
    const ext = f.name.split(".").pop();
    if (ext === "csv") {
      setFile(f);
      setError("");
    } else {
      setFile(null);
      setError("Only csv archives supported");
    }
  };

  return (
    <>
      <Header as="h3" content={"Select CSV file"} />
      <Input
        type="file"
        name="dataset"
        accept=".csv"
        style={{ display: "block", marginBottom: "1em" }}
        onChange={(e) => validateFile(e.target.files[0])}
        error={error}
      />
      <br />
      <Button onClick={() => closeModal()} content="Cancel" />
      <Button
        color="blue"
        disabled={!file}
        onClick={() => {
          dispatch(recordingBulkUpdate(projectId, file));
          closeModal();
        }}
        content="Update"
      />
    </>
  );
};

RecordingBulkUpdateForm.propTypes = {
  projectId: PropTypes.string.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default RecordingBulkUpdateForm;
